import React, { useEffect, useState } from 'react'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { useLocation, useNavigate } from 'react-router-dom';
import classes from "./style.module.scss";
import FileUpload from '../../../../component/FileUpload';
import ProductUpload from './ProductUpload';
import { Images } from '../../../../assets';
import { Controller, FormProvider, useForm } from "react-hook-form";
import InputBox from '../../../../component/InputBox';
import SelectBox from '../../../../component/SelectBox';
import Button from '../../../../component/Button';
import { applicationDropdown, BULK_FILTRATION, Filters, subCategoryDropdown, TRUCK_SOLUTIONS } from '../../../../helpers';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import MultiSelectComponent from '../../../../component/MultiSelect';
import GetUserPermission from '../../../../component/GetUserPermission';


const AddProduct = ({ currentTab }) => {
    const INDIVIDUAL = 'Individual'
    const BULK = 'Bulk'
    const productList = [INDIVIDUAL, BULK];

    const [subList, setSubList] = useState([])
    const [applicationList, setApplicationList] = useState([])
    const [refId, setRefId] = useState(null);
    const [activeTab, setActiveTab] = useState(INDIVIDUAL)
    const [productTab, setProductTab] = useState([])
    const [fileName, setFileName] = useState('');
    const [imageFileName, setImageFileName] = useState('');
    const [uploadedFiles, setUploadedFiles] = useState(null);
    const [uploadedImages, setUploadedImages] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [isEdit, setIsEdit] = useState(false)
    const [uploadedUrl, setUploadedUrl] = useState([]);
    const [productImage, setProductImage] = useState([]);
    const [selectedType, setSelectedType] = useState('');
    const [getid, setGetid] = useState()
    const location = useLocation();
    const parentTab = currentTab
    const navigate = useNavigate();
    const addPermission = GetUserPermission({ key: 'add', microAppPath: 'product-catalog' });
    const editPermission = GetUserPermission({ key: 'edit', microAppPath: 'product-catalog' });

    const formMethods = useForm({
        mode: "onSubmit",
    });
    const {
        handleSubmit,
        formState: { errors },
        trigger,
        register,
        control,
        setValue,
        reset,
        watch,
        clearErrors,
    } = formMethods;

    const kgFilterGeneral = [
        { label: "Reference Number", name: "reference_number", required: false },
        { label: "Retailer Points", name: "retailer_points", required: false },
        { label: "Mechanic Points", name: "mechanic_points", required: false },

    ]

    const kgFilterCrossReference = [
        { label: "Baldwin", name: "baldwin" },
        { label: "Fleetguard", name: "fleetguard" },
        { label: "Hifi", name: "hifi" },
        { label: "Sakura", name: "sakura" },
        { label: "Donaldson", name: "donaldson" },
        { label: "Hengst", name: "hengst" },
        { label: "Mann", name: "mann" },
        { label: "Wix", name: "wix" },
    ]

    const kgTruckSolutionsGeneralInfo = [
        { label: "Reference Number", name: "reference_number" },
        { label: "d_mm", name: "d_mm" },
        { label: "D_mm", name: "D_mm" },
        { label: "B_mm", name: "B_mm" },
        { label: "Retailer Points", name: "retailer_points" },
        { label: "Mechanic Points", name: "mechanic_points" },
    ]

    const kgTruckSolutionsBrandRef = [
        { label: "SKF", name: "skf" },
        { label: "FAG", name: "fag" },
        { label: "Timken", name: "timken" },
        { label: "Koyo", name: "koyo" },
        { label: "SAF", name: "saf" },
        { label: "SNR", name: "snr" },
    ]

    const kgTruckSolutionsApplicationRef = [
        { label: "Mercedes", name: "mercedes" },
        { label: "Man", name: "man" },
        { label: "Scania", name: "scania" },
        { label: "DAF", name: "daf" },
        { label: "Iveco", name: "iveco" },
        { label: "Volvo", name: "volvo" },
        { label: "Nissan", name: "nissan" },
        { label: "Renault", name: "renault" },
        { label: "Schmitz Cargobull", name: "schmitz_cargobull" },
    ]

    useEffect(() => {
        if (isEdit) {
            if (!editPermission) {
                redirectBack()
            }
        } else {
            if (!addPermission) {
                redirectBack()
            }
        }
    }, [isEdit])

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        var type = searchParams.get('type') || location.search?.split(('?type='))?.at(1)?.split('&')[0]
        var refId = searchParams.get('refId') || location.search?.split(('&refId='))?.at(1)?.split('?')[0]

        setRefId(refId);
        if (type === 'edit' && refId) {
            setIsEdit(true)
        } else {
            setIsEdit(false)
        }
    }, [location.search])


    const redirectBack = () => {
        navigate('')
    }

    const subDropdown = async () => {
        await subCategoryDropdown().then((res) => {
            const formattedList = res.map(it => ({
                id: it.id,
                label: it.title,
                value: it.title,
            }));
            setSubList(formattedList);
        }).catch((err) => {
            console.log(err)
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const appDropdown = async () => {
        await applicationDropdown().then((res) => {
            const formattedList = res.map(it => ({
                label: it.title,
                value: it.title,
                id: it.id,
            }));
            setApplicationList(formattedList);
        }).catch((err) => {
            console.log(err)
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    useEffect(() => {
        if (parentTab === Filters) {
            subDropdown()
        }

        appDropdown()
    }, [])

    const filtersUpload = async () => {
        const formData = new FormData();
        formData.append('file', uploadedFiles[0])


        await request({
            url: Exported.Endpoints.filterUpload,
            method: Exported.APIMethods.POST,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }).then((res) => {
            console.log(res)
            Toast({
                type: 'success',
                message: 'Uploaded successfully'
            })
            redirectBack()
        }).catch((err) => {
            console.log(err)
        })
    }

    const truckSolutionsUpload = async () => {
        const formData = new FormData();
        formData.append('file', uploadedFiles[0])


        await request({
            url: Exported.Endpoints.truckSolutionUpload,
            method: Exported.APIMethods.POST,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }).then((res) => {
            console.log(res)
            Toast({
                type: 'success',
                message: 'Uploaded successfully'
            })
            redirectBack()
        }).catch((err) => {
            console.log(err)
        })
    }

    const handleChange = (selected) => {
        const selectedIds = selected.map((item) => item.value);
        setSelectedOptions(selected);

    };

    const imageUpload = async () => {
        const formData = new FormData();
        formData.append('file', uploadedImages[0]);

        await request({
            url: Exported.Endpoints.singleUpload,
            method: Exported.APIMethods.POST,
            data: formData,
            headers: {
                'content-type': 'multipart/form-data',
            },
        }).then((res) => {
            console.log(res);
            setUploadedUrl([res?.data?.data?.url])
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        const id = subList.find((item) => item.label === watch('type'))?.id || 1;
        setGetid(id);
    }, [watch('type')]);

    useEffect(() => {
        if (uploadedImages && uploadedImages.length > 0)
            imageUpload()
    }, [uploadedImages])

    const getEndpoints = (currentTab) => {
        let endPoints = Exported.Endpoints.getFilter
        if (currentTab == Filters) {
            endPoints = Exported.Endpoints.getFilter
        } else if (currentTab == TRUCK_SOLUTIONS) {
            endPoints = Exported.Endpoints.getTruckSolution
        } else if (currentTab == BULK_FILTRATION) {
            endPoints = Exported.Endpoints.getBulkFilter
        }
        return endPoints
    }

    const onSubmit = async (data) => {
        if (isEdit) {
            trigger()
            let url = `${getEndpoints(currentTab)}/${refId}`
            let editFilterData = {
                baldwin: data.baldwin !== '' ? data.baldwin : null,
                fleetguard: data.fleetguard !== '' ? data.fleetguard : null,
                hifi: data.hifi !== '' ? data.hifi : null,
                sakura: data.sakura !== '' ? data.sakura : null,
                donaldson: data.donaldson !== '' ? data.donaldson : null,
                hengst: data.hengst !== '' ? data.hengst : null,
                mann: data.mann !== '' ? data.mann : null,
                wix: data.wix !== '' ? data.wix : null,
                retailer_points: data.retailer_points !== '' ? data.retailer_points : null,
                mechanic_points: data.mechanic_points !== '' ? data.mechanic_points : null,
                quantity: activeTab === "Bulk" ? data.quantity : 0,
                application_ids: selectedOptions?.map((it) => it?.id),
                images: uploadedUrl || []
            }

            let editTruckSolutionsData = {
                d_mm: data.d_mm !== '' ? data.d_mm : null,
                D__mm: data.D_mm !== '' ? data.D_mm : null,
                B_mm: data.B_mm !== '' ? data.B_mm : null,
                brand_skf: data.skf !== '' ? data.skf : null,
                brand_fag: data.fag !== '' ? data.fag : null,
                brand_timken: data.timken !== '' ? data.timken : null,
                brand_koyo: data.koyo !== '' ? data.koyo : null,
                brand_saf: data.saf !== '' ? data.saf : null,
                brand_snr: data.snr !== '' ? data.snr : null,
                app_mercedes: data.mercedes !== '' ? data.mercedes : null,
                app_man: data.man !== '' ? data.man : null,
                app_scania: data.scania !== '' ? data.scania : null,
                app_daf: data.daf !== '' ? data.daf : null,
                app_iveco: data.iveco !== '' ? data.iveco : null,
                app_volvo: data.volvo !== '' ? data.volvo : null,
                app_nissan: data.nissan !== '' ? data.nissan : null,
                app_renault: data.renault !== '' ? data.renault : null,
                app_schmitz_cargobull: data.schmitz_cargobull !== '' ? data.schmitz_cargobull : null,
                retailer_points: data.retailer_points !== '' ? data.retailer_points : null,
                mechanic_points: data.mechanic_points !== '' ? data.mechanic_points : null,
                item_type: activeTab === "Individual" ? 1 : activeTab === "Bulk" ? 2 : null,
                quantity: activeTab === "Bulk" ? data.quantity : 0,
                application_ids: selectedOptions?.map((it) => it?.id),
                images: uploadedUrl || []
            }
            await request({
                url: url,
                method: Exported.APIMethods.PUT,
                data: currentTab == TRUCK_SOLUTIONS ? editTruckSolutionsData : editFilterData,
            }).then((res) => {
                console.log(res)
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
                navigate('')
            }).catch((err) => {
                Toast({
                    type: 'error',
                    message: err?.response?.data?.message,
                });
                console.log(err)
            })

        }
        else {
            trigger()
            setGetid(subList.find((item) => item.label == data.type)?.id || 1)
            let filterData = {
                reference_number: data.reference_number !== '' ? data.reference_number : null,
                sub_category_id: getid,
                baldwin: data.baldwin !== '' ? data.baldwin : null,
                fleetguard: data.fleetguard !== '' ? data.fleetguard : null,
                hifi: data.hifi !== '' ? data.hifi : null,
                sakura: data.sakura !== '' ? data.sakura : null,
                donaldson: data.donaldson !== '' ? data.donaldson : null,
                hengst: data.hengst !== '' ? data.hengst : null,
                mann: data.mann !== '' ? data.mann : null,
                wix: data.wix !== '' ? data.wix : null,
                retailer_points: data.retailer_points !== '' ? data.retailer_points : null,
                mechanic_points: data.mechanic_points !== '' ? data.mechanic_points : null,
                item_type: activeTab === "Individual" ? 1 : activeTab === "Bulk" ? 2 : null,
                quantity: activeTab === "Bulk" ? data.quantity : 0,
                application_ids: selectedOptions?.map((it) => it?.id),
                images: uploadedUrl || []
            }

            let truckSolutionsData = {
                reference_number: data.reference_number !== '' ? data.reference_number : null,
                d_mm: data.d_mm !== '' ? data.d_mm : null,
                D__mm: data.D_mm !== '' ? data.D_mm : null,
                B_mm: data.B_mm !== '' ? data.B_mm : null,
                brand_skf: data.skf !== '' ? data.skf : null,
                brand_fag: data.fag !== '' ? data.fag : null,
                brand_timken: data.timken !== '' ? data.timken : null,
                brand_koyo: data.koyo !== '' ? data.koyo : null,
                brand_saf: data.saf !== '' ? data.saf : null,
                brand_snr: data.snr !== '' ? data.snr : null,
                app_mercedes: data.mercedes !== '' ? data.mercedes : null,
                app_man: data.man !== '' ? data.man : null,
                app_scania: data.scania !== '' ? data.scania : null,
                app_daf: data.daf !== '' ? data.daf : null,
                app_iveco: data.iveco !== '' ? data.iveco : null,
                app_volvo: data.volvo !== '' ? data.volvo : null,
                app_nissan: data.nissan !== '' ? data.nissan : null,
                app_renault: data.renault !== '' ? data.renault : null,
                app_schmitz_cargobull: data.schmitz_cargobull !== '' ? data.schmitz_cargobull : null,
                retailer_points: data.retailer_points !== '' ? data.retailer_points : null,
                mechanic_points: data.mechanic_points !== '' ? data.mechanic_points : null,
                item_type: activeTab === "Individual" ? 1 : activeTab === "Bulk" ? 2 : null,
                quantity: activeTab === "Bulk" ? data.quantity : 0,
                application_ids: selectedOptions?.map((it) => it?.id),
                images: uploadedUrl || []
            }
            if (parentTab === Filters) {
                if (fileName.length > 0) {
                    await filtersUpload()

                    clearErrors()
                } else {
                    await request({
                        url: Exported.Endpoints.getFilter,
                        method: Exported.APIMethods.POST,
                        data: { ...filterData },
                    })
                        .then((res) => {
                            if (res?.data?.status) {
                                console.log(res);
                                Toast({
                                    type: 'success',
                                    message: 'Created successfully'
                                })
                                redirectBack()
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            Toast({
                                type: 'error',
                                message: err?.response?.data?.message,
                            });
                        });
                }
            }

            else if (parentTab === TRUCK_SOLUTIONS) {
                if (uploadedFiles) {
                    await truckSolutionsUpload()
                } else {
                    await request({
                        url: Exported.Endpoints.getTruckSolution,
                        method: Exported.APIMethods.POST,
                        data: { ...truckSolutionsData }
                    }).then((res) => {
                        if (res?.data?.status) {
                            console.log(res);
                            Toast({
                                type: 'success',
                                message: 'Created successfully'
                            })
                            redirectBack()
                        }
                    }).catch((err) => {
                        console.log(err)
                        Toast({
                            type: 'error',
                            message: err?.response?.data?.message,
                        })
                    })
                }
            }
            else {
                alert("Select Tab")
            }
        }


    }



    const getSpecificFilterProduct = async (id) => {
        let url = `${Exported.Endpoints.getFilter}/${id}`
        await request({
            url: url,
            method: Exported.APIMethods.GET,
        }).then((res) => {

            const data = res?.data?.data;
            const subCategoryTitle = data?.product_details?.product_sub_category?.title;
            const selectedIds = data?.applications?.map((item) => ({
                id: item.id,
                label: item.title,
            }))
            if (data?.product_details?.images?.length > 0) {
                const imageName = data?.product_details?.images
                const getImageName = imageName[0].split('---')
                setImageFileName([getImageName[1]?.replace("%20", "")])
                setUploadedUrl(data?.product_details?.images)
            }

            setSelectedType(subCategoryTitle)
            setSelectedOptions([...selectedIds])
            setValue("reference_number", data?.product_details?.reference_number)
            setValue("type", data?.product_details?.product_sub_category?.title)
            setValue("baldwin", data?.baldwin)
            setValue("fleetguard", data?.fleetguard)
            setValue("hifi", data?.hifi)
            setValue("sakura", data?.sakura)
            setValue("donaldson", data?.donaldson)
            setValue("hengst", data?.hengst)
            setValue("mann", data?.mann)
            setValue("wix", data?.wix)
            setValue("retailer_points", data?.product_details?.retailer_points)
            setValue("mechanic_points", data?.product_details?.mechanic_points)
            setValue("quantity", data?.quantity)
            setValue("selectedOptions", selectedIds);
        }).catch((err) => {
            console.log(err, "err")
        })
    }

    const getSpecificTruckSolutions = async (id) => {
        let url = `${Exported.Endpoints.getTruckSolution}/${id}`;
        await request({
            url: url,
            method: Exported.APIMethods.GET,
        })
            .then((res) => {
                const data = res?.data?.data;
                const selectedIds = data?.transformedApplications?.map((item) => ({
                    id: item.id,
                    label: item.title,
                }))
                if (data?.product_details?.images?.length > 0) {
                    const imageName = data?.product_details?.images
                    const getImageName = imageName[0].split('---')
                    setImageFileName([getImageName[1]?.replace("%20", "")])
                    setUploadedUrl(data?.product_details?.images)
                }
                setSelectedOptions([...selectedIds])
                setValue("reference_number", data?.product_details?.reference_number);
                setValue("retailer_points", data?.product_details?.retailer_points);
                setValue("mechanic_points", data?.product_details?.mechanic_points);
                setValue("d_mm", data?.d_mm);
                setValue("D_mm", data?.D__mm);
                setValue("B_mm", data?.B_mm);
                setValue("skf", data?.brand_skf);
                setValue("fag", data?.brand_fag);
                setValue("timken", data?.brand_timken);
                setValue("koyo", data?.brand_koyo);
                setValue("saf", data?.brand_saf);
                setValue("snr", data?.brand_snr);
                setValue("mercedes", data?.app_mercedes);
                setValue("man", data?.app_man);
                setValue("scania", data?.app_scania);
                setValue("daf", data?.app_daf);
                setValue("iveco", data?.app_iveco);
                setValue("volvo", data?.app_volvo);
                setValue("nissan", data?.app_nissan);
                setValue("renault", data?.app_renault);
                setValue("schmitz_cargobull", data?.app_schmitz_cargobull);
                setValue("selectedOptions", selectedIds);

                const truckImage = [{ value: data?.product_details?.images }];
                setProductImage(truckImage);
            })
            .catch((err) => {
                console.log(err, "truck error");
            });
    };

    useEffect(() => {
        if (isEdit && selectedType) {
            setValue('type', selectedType || "");
        }
    }, [isEdit, selectedType, setValue]);

    useEffect(() => {
        if (isEdit) {
            if (parentTab === Filters) {
                getSpecificFilterProduct(refId)
            } else if (parentTab === TRUCK_SOLUTIONS) {
                getSpecificTruckSolutions(refId)
            }
        }
    }, [isEdit, refId, reset])

    useEffect(() => {
        if (parentTab === Filters) {
            setProductTab([
                { label: "General Info", field: kgFilterGeneral, select: true, quantity: true, appsId: true },
                { label: "Cross Reference", field: kgFilterCrossReference },
            ])
        } else if (parentTab === TRUCK_SOLUTIONS) {
            setProductTab([
                { label: "General Info", field: kgTruckSolutionsGeneralInfo, quantity: true, appsId: true },
                { label: "Brand Reference", field: kgTruckSolutionsBrandRef },
                { label: "Application Reference", field: kgTruckSolutionsApplicationRef },
            ])
        }
    }, [parentTab])
    return (
        <div>
            <div className={`layout-title flex items-center`}>
                <div className='mr-2 flex items-center cursor-pointer' onClick={() => redirectBack()}>
                    <ArrowBackIosOutlinedIcon />
                </div>
                <div>{isEdit ? 'Edit' : 'Add'} Product</div>
            </div>
            {!isEdit &&
                <div className={`${classes.headerList} w-[100%] flex items-center`}>
                    {productList?.map((title) => <div className={`${classes.headerTab} ${activeTab === title ? classes.activeTab : ''}`} onClick={() => setActiveTab(title)}>{title}</div>)}
                </div>
            }
            <div>
                <div>
                    <FormProvider {...formMethods}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {!isEdit &&
                                <>
                                    <ProductUpload text={"Upload Product detail sheet"} placeholder={"Upload File (Max: 20 MB)"} fileName={fileName} setFileName={setFileName} files={uploadedFiles} setFiles={setUploadedFiles} />
                                    <img src={Images.breakLine} className='my-6' />
                                </>
                            }
                            <div className={`${classes.createRoleAdminWrapper} mt-3`}>
                                {
                                    productTab.map((it, index) => (
                                        <>
                                            <div className={classes.titleHeader}>{it?.label}</div>
                                            <div className={`${classes.formGroup} mt-5`}>
                                                {
                                                    it?.field?.map((data) => (
                                                        <div className={`${classes.formField}`}>
                                                            <InputBox
                                                                label={data.label}
                                                                className={`w-[100%]`}
                                                                disabled={isEdit ? (data.name === "reference_number" ? true : false) : false}
                                                                name={data.name}
                                                                placeholder={data.label}
                                                                isEdit={isEdit}
                                                                {...register(data.name, {
                                                                    required: (fileName?.length > 0 || !data?.required) ? false : true,
                                                                })}
                                                                error={fileName.length > 0 ? "" : errors[data.name]}
                                                                messages={{
                                                                    required: fileName?.length > 0 ? "" : `${data.label} is required`,
                                                                }}
                                                            />
                                                        </div>

                                                    ))
                                                }

                                                {/* {it.select &&
                                                    <div className={`${classes.formField}`}>
                                                        <SelectBox
                                                            className={`w-[100%]`}
                                                            {...register("type", {
                                                                required: fileName?.length > 0 ? false : true,
                                                            })}
                                                            disabled={isEdit ? true : false}
                                                            // value={watch('type') || ""}
                                                            label={'Sub Category'}
                                                            list={subList}
                                                            // onChange={(e) => setValue('type', e.target.value)}
                                                            name='type'
                                                            placeholder={'Sub Category'}
                                                            error={fileName.length > 0 ? "" : errors.type}
                                                            messages={{
                                                                required: fileName.length > 0 ? "" : " Sub Category is required",
                                                            }}
                                                        />

                                                    </div>
                                                } */}
                                                {it.select &&
                                                    <div className={`${classes.formField}`}>
                                                        <Controller
                                                            name="type"
                                                            control={formMethods?.control}
                                                            defaultValue=""
                                                            rules={{ required: false }}
                                                            render={({ field }) => (
                                                                <SelectBox
                                                                    label="Sub Category"
                                                                    placeholder="Sub Category"
                                                                    list={subList}
                                                                    isEdit={isEdit}
                                                                    disabled={isEdit ? true : false}
                                                                    {...field}
                                                                    // error={errors.type}
                                                                    // messages={{
                                                                    //     required: "Sub Category is required",
                                                                    // }}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                }

                                                {it.appsId &&
                                                    <div className={`${classes.formField}`}>
                                                        <MultiSelectComponent
                                                            name="selectedOptions"
                                                            value={selectedOptions}
                                                            handleChange={handleChange}
                                                            control={control}
                                                            label="Application Ids"
                                                            options={applicationList}
                                                            // error={fileName.length > 0 ? "" : errors.selectedOptions}
                                                            // messages={{
                                                            //     required: fileName.length > 0 ? "" : "Application Ids is required",
                                                            // }}
                                                            required={false}
                                                        />

                                                    </div>
                                                }

                                                {activeTab === "Bulk" && it.quantity ? (
                                                    <InputBox
                                                        label={"Quantity"}
                                                        className={`w-[100%]`}
                                                        name={"quantity"}
                                                        placeholder={'Quantity'}
                                                        {...register("quantity", {
                                                            required: false,
                                                        })}
                                                        // error={errors.title}
                                                        // messages={{
                                                        //     required: "Quantity is required",
                                                        // }}
                                                        required={false}
                                                    />) : null
                                                }

                                            </div>
                                        </>
                                    ))}
                            </div>
                            <ProductUpload text={"Upload"} placeholder={"Upload Images (Max: 20 MB)"} fileName={imageFileName} setFileName={setImageFileName} files={uploadedImages} setFiles={setUploadedImages} acceptFiles="image/png, image/jpg, image/jpeg, image/svg+xml" />
                            <div className='flex gap-4 justify-end mb-6'>
                                <Button text="Cancel" style={{ width: "160px", backgroundColor: 'transparent', color: '#1F2155', height: "40px", fontSize: "16px" }} />
                                <Button text="Save" style={{ width: "170px", height: "40px", fontSize: "16px" }} />
                            </div>
                        </form>
                    </FormProvider>

                </div>
            </div>
        </div>
    )
}

export default AddProduct